import { render, staticRenderFns } from "./import-inbound-outbound.vue?vue&type=template&id=0dc54188&scoped=true&"
import script from "./import-inbound-outbound.vue?vue&type=script&lang=js&"
export * from "./import-inbound-outbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc54188",
  null
  
)

export default component.exports